import { observable, action, runInAction, makeObservable } from "mobx";
import gtmTarget from "../utils/gtmTarget";

class Search {
  searchVisible = false;

  showExtendedSearchPopup = false;

  constructor(rootStore) {
    makeObservable(this, {
      searchVisible: observable,
      showExtendedSearchPopup: observable,
      showSearch: action,
      hideSearch: action,
      openExtendedSearchPopup: action,
      closeExtendedSearchPopup: action,
    });

    this.rootStore = rootStore;
  }

  showSearch = (event) => {
    event.preventDefault();
    gtmTarget("header-show-search");
    setTimeout(() => {
      runInAction(() => {
        this.rootStore.header.setBodyOverflow(true);
        this.rootStore.header.setOverlay(true);
        this.searchVisible = true;
      });
    }, 0);
  };

  hideSearch = () => {
    this.rootStore.header.setBodyOverflow(false);
    this.rootStore.header.setOverlay(false);
    this.searchVisible = false;
  };

  openExtendedSearchPopup = () => {
    this.showExtendedSearchPopup = true;
    window.addEventListener("message", this.postMessageEvent, false);
  };

  closeExtendedSearchPopup = () => {
    this.showExtendedSearchPopup = false;
    window.removeEventListener("message", this.postMessageEvent, false);
  };

  postMessageEvent = (event) => {
    let parsedEvent;
    if (!event || !event.data) {
      return;
    }
    try {
      parsedEvent = JSON.parse(event.data);
      if (!parsedEvent || !parsedEvent.eventType) {
        return;
      }
    } catch (e) {
      return;
    }
    switch (parsedEvent.eventType) {
      case "selectExtendedSearchPopup":
      case "closeExtendedSearchPopup":
        this.closeExtendedSearchPopup();
        break;
      default:
        break;
    }
  };
}

export default Search;
